import { Col, Row, Select } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';
import { Months } from '../../models';
import { EstadosRegistro } from '../../models/Consultas';
import { UserStore, AperturaStore } from '../../stores';
import consultaStore, { ConsultaStore } from '../../stores/consultaStore';

const HeaderContainer = styled.div`
    text-align: center;
`;
const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

interface ConsultasHeaderProps {
    consultaStore?: ConsultaStore;
    userStore?: UserStore;
    aperturaStore?: AperturaStore;
}

@inject('consultaStore')
@inject('userStore')
@inject('aperturaStore')
@observer
class ConsultasHeader extends React.Component<ConsultasHeaderProps> {
    renderMunicipio = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.handleMunicipio}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipios.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    handleMunicipio = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Municipio = value;
        this.consulta();
    };
    async consulta() {
        const { consultaStore, userStore } = this.props;
        await consultaStore!.getConsulta(false);
        userStore!.rol === 'ROL-RM' || userStore!.rol === 'ROL-ROO'
            ? null
            : await consultaStore!.getConsultaMensual();
    }

    renderEjercicio = () => {
        const fecha = new Date();
        let arreEjercicio = [];
        for (var i = fecha.getFullYear(); i >= fecha.getFullYear() - 5; i--) {
            arreEjercicio.push(i);
        }
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Ejercicio"
                optionFilterProp="children"
                onChange={this.handleEjercicio}
                defaultValue={fecha.getFullYear()}
            >
                {arreEjercicio.map((value, index) => (
                    <Select.Option key={value}>{value}</Select.Option>
                ))}
            </Select>
        );
    };
    handleEjercicio = async (value: any) => {
        const { consultaStore, userStore } = this.props;
        consultaStore!.filtros!.Ejercicio = value;
        await consultaStore!.getConsulta(false);
        userStore!.rol === 'ROL-RM' || userStore!.rol === 'ROL-ROO'
            ? null
            : await consultaStore!.getConsultaMensual();
    };

    renderMeses = () => {
        const { aperturaStore } = this.props;
        aperturaStore!.limpiarFiltrosConsulta();
        aperturaStore!.obtenerUltimaApertura();
        const fecha = new Date();
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Mes"
                optionFilterProp="children"
                onChange={this.handleMeses}
                defaultValue={'Enero'}
            >
                {consultaStore!.filtros.Ejercicio == fecha.getFullYear()
                    ? Months.map((mes, index) =>
                          index < aperturaStore!.ultimoMesActivo ? (
                              <Select.Option key={index + 1}>{mes}</Select.Option>
                          ) : null
                      )
                    : Months.map((mes, index) => (
                          <Select.Option key={index + 1}>{mes}</Select.Option>
                      ))}
            </Select>
        );
    };
    handleMeses = async (value: any) => {
        const { consultaStore, userStore } = this.props;
        consultaStore!.filtros!.Mes = value;
        await consultaStore!.getConsulta(false);
        userStore!.rol === 'ROL-RM' || userStore!.rol === 'ROL-ROO'
            ? null
            : await consultaStore!.getConsultaMensual();
    };

    renderTipo = () => {
        const { userStore } = this.props;
        return (
            <Select style={{ width: '100%' }} placeholder="Todos" onChange={this.handleTipo}>
                <Select.Option key={'0'}>Todos</Select.Option>
                {userStore!.rol === 'ROL-ROO' ? null : (
                <Select.Option key={'2'}>Predial</Select.Option>)}
                <Select.Option key={'1'}>Agua</Select.Option>
            </Select>
        );
    };
    handleTipo = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Tipo = value;
        consultaStore!.getConsulta(false);
    };

    renderEstatus = () => {
        return (
            <Select style={{ width: '100%' }} placeholder="Todos" onChange={this.handleEstatus}>
                <Select.Option key={'0'}>Todos</Select.Option>
                <Select.Option key={'5'}>Sin Captura</Select.Option>
                <Select.Option key={'1'}>Guardado</Select.Option>
                <Select.Option key={'2'}>Capturado</Select.Option>
                <Select.Option key={'4'}>Rechazado</Select.Option>
                <Select.Option key={'6'}>Corregido</Select.Option>
                <Select.Option key={'3'}>Aprobado</Select.Option>
            </Select>
        );
    };
    handleEstatus = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Estado = value;
        consultaStore!.getConsulta(false);
    };

    renderTipoCaptura = () => {
        const { userStore } = this.props;
        return (
            <Select style={{ width: '100%' }} placeholder="Todos" onChange={this.handleTipoCaptura}>
                <Select.Option key={'0'}>Todos</Select.Option>
                {userStore!.rol === 'ROL-ROO' ? null : (
                <Select.Option key={'MUNI'}>Municipio</Select.Option>)}
                <Select.Option key={'OO'}>Organismo Operador</Select.Option>
            </Select>
        );
    };
    handleTipoCaptura = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Captura = value;
        consultaStore!.getConsulta(false);
    };

    renderFiltros = () => {
        const { userStore } = this.props;
        return (
            <>
                {userStore!.rol === 'ROL-RM' ? null : (
                    <Col span={4}>
                        <strong> Municipio</strong> {this.renderMunicipio()}
                    </Col>
                )}
                <Col span={4}>
                    <strong>Ejercicio</strong>
                    {this.renderEjercicio()}
                </Col>
                <Col span={4}>
                    <strong>Mes</strong>
                    {this.renderMeses()}
                </Col>
                <Col span={4}>
                    <strong>Tipo Recaudación</strong>
                    {this.renderTipo()}
                </Col>
                <Col span={4}>
                    <strong>Estatus</strong>
                    {this.renderEstatus()}
                </Col>
                <Col span={4}>
                    <strong>Tipo Captura</strong>
                    {this.renderTipoCaptura()}
                </Col>
            </>
        );
    };

    render() {
        return (
            <HeaderContainer>
                <Row>
                    <PageHeader>Consulta de Captura de Cifras de Recaudación </PageHeader>
                </Row>
                <Row style={{ textAlign: 'center', paddingTop: '15px' }}>
                    {this.renderFiltros()}
                </Row>
                <br />
            </HeaderContainer>
        );
    }
}
export default ConsultasHeader;
